import { HTTP_STATUS_CODE, IHttpGet } from '../../adapters';
import { IResponseDTO } from './dto';
import {
  IGetBenchmarkColor,
  IGetAssetMemory,
  ISetAssetMemory,
  IBenchmarkStats,
} from '../../interfaces';

export class BenchmarkStatsUseCase {
  constructor (
    private readonly url: string,
    private readonly http: IHttpGet<IBenchmarkStats>,
    private readonly benchmarkColorRepo: IGetBenchmarkColor,
    private readonly benchmarkInMemoryRepo: IGetAssetMemory<IBenchmarkStats> & ISetAssetMemory<IBenchmarkStats>
  ) {}

  public async execute(benchmarksStrings: string[]): Promise<IResponseDTO> {
    const benchmarksWithoutRepeatValues = [...new Set(benchmarksStrings)];

    const benchmarksStats = await Promise.all(benchmarksWithoutRepeatValues.map(async (id) => {
      const inMemory = this.benchmarkInMemoryRepo.get(id);

      if (inMemory) {
        return inMemory;
      }

      const { statusCode, body } = await this.http.get({
        url: `${this.url}/${id}/details`,
      });

      if (statusCode === HTTP_STATUS_CODE.ok) {
        const newBenchmark = {
          ...body,
          id,
        }

        this.benchmarkInMemoryRepo.set(id, newBenchmark);

        return newBenchmark;
      }

      return null;
    }));

    const benchmarksWithoutNullValues = benchmarksStats.filter(Boolean);

    const benchmarkWithColors = benchmarksWithoutNullValues.map((benchmark) => ({
      ...benchmark,
      color: this.benchmarkColorRepo.getColor(benchmark.id)
    }));

    return {
      benchmarkStats: benchmarkWithColors
    };
  }
}
